import { render, staticRenderFns } from "./Costi.vue?vue&type=template&id=65222048&"
import script from "./Costi.vue?vue&type=script&lang=js&"
export * from "./Costi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports